import { Component, HostBinding, Input } from '@angular/core';
import { AngularMaterialModule } from '../../angular-material.module';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'mytc-button-loading',
  templateUrl: './button-loading.component.html',
  styleUrls: ['./button-loading.component.scss'],
  imports: [AngularMaterialModule, NgTemplateOutlet],
})
export class ButtonLoadingComponent {
  @Input() diameter: number;
  @Input() withAbsoluteWrapper = false;

  @Input()
  @HostBinding('style.--stroke-color')
  spinnerColor = 'var(--mytc-white)';
}
